import * as React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller } from "react-hook-form";
import { RenderLabelChip } from '../Helpers';

export const SelectMultipleField: any = ({
  name,
  control,
  label,
  options,
  required = false,
  multiple = true,
}) => {
  if (!options || !Array.isArray(options)) return null;

  const extractValue = (item: any) => {
    if (typeof item === 'string') return item;
    if (item?.['@id']) return item['@id'];
    if (item?.value) return item.value;
    return '';
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>{`${label}${required ? '*' : ''}`}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={[]}
        render={({ field: { onChange, value } }) => {
          const normalizedValue = multiple
            ? Array.isArray(value) ? value.map(extractValue) : []
            : extractValue(value?.[0]);

          const handleChange = (e) => {
            const selected = e.target.value;
            const result = multiple
              ? selected
              : selected ? [selected] : [];
            onChange(result);
          };

          return (
            <Select
              label={label}
              multiple={multiple}
              value={normalizedValue}
              onChange={handleChange}
              required={required}
              fullWidth
            >
              <MenuItem value="" disabled>Select</MenuItem>
              {options.map((option: any) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.color
                    ? RenderLabelChip(option.label, option.color)
                    : option.label}
                </MenuItem>
              ))}
            </Select>
          );
        }}
      />
    </FormControl>
  );
};